export class usuario_rol {
    rut_usuario: number;
    roles_codigo: number;
    fecha_asignacion: Date;
}